import React from "react";
var TrackTitleError;
(function (TrackTitleError) {
    TrackTitleError["Empty"] = "empty";
})(TrackTitleError || (TrackTitleError = {}));
var mapErrorToMessage = function (key) {
    var _a;
    if (!key)
        return "";
    return (_a = {}, _a[TrackTitleError.Empty] = "Введите название", _a)[key];
};
export var useTrackTitleEdit = function (initial) {
    var _a = React.useState(initial), title = _a[0], setTitle = _a[1];
    var _b = React.useState(null), error = _b[0], setError = _b[1];
    var validate = function () {
        var key = null;
        if (title.length === 0) {
            key = TrackTitleError.Empty;
        }
        setError(key);
        return key === null;
    };
    return {
        value: title,
        set: setTitle,
        error: {
            value: Boolean(error),
            set: setError,
            key: error,
            message: mapErrorToMessage(error),
        },
        validate: validate,
    };
};
